export function isEmail(value) {
  return window.App.shared.RegexManager.isEmail(value);
}

export function isMobile() {
  return window.matchMedia('(max-width: 767.98px)').matches;
}

export function isMobileEnquiryForm() {
  return window.matchMedia('(max-width: 1279.98px)').matches;
}

/**
 * @param {string} date
 * @param {array} dates
 * @returns {boolean}
 */
export function isDateFullyBooked(date, dates) {
  return dates.indexOf(date) !== -1;
}

/**
 * @param {string} date
 * @param {object} dates
 * @returns {boolean}
 */
export function isDatePartiallyBooked(date, dates) {
  return !!dates[date];
}

/**
 * 16/08/2019 => 2019-08-16
 * @param {string} date
 */
export function parseToInternalDateFormat(date) {
  if (!date) {
    return null;
  }

  const [day, month, year] = date.split('/');

  return `${year}-${month}-${day}`;
}

/**
 * @param {array} items
 * @param {number|string} id
 * @returns {*}
 */
export const findById = (items, id) => items.filter(item => item.id === id)[0];

/**
 * @param {array} ranges
 * @returns {number}
 */
export const getMinFromRanges = (ranges) => {
  return Math.min(...ranges.map(pair => pair[0]));
};

/**
 * @param {array} ranges
 * @returns {number}
 */
export const getMaxFromRanges = (ranges) => {
  return Math.max(...ranges.map(pair => pair[1]));
};

export const weekDaysMap = {
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
};

export const DAY_CODES = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

export const weekDaysMapReversed = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};
